import { render } from "./KpiDetails.vue?vue&type=template&id=39bb083a&scoped=true"
import script from "./KpiDetails.vue?vue&type=script&lang=js"
export * from "./KpiDetails.vue?vue&type=script&lang=js"

import "./KpiDetails.vue?vue&type=style&index=0&id=39bb083a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bb083a"]])

export default __exports__